import React from 'react';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ModalProvider, ToastMarker } from 'msys-ds';

import store from 'config/store';
import history from 'config/history';
import App from 'App';
import * as serviceWorker from 'serviceWorker';
import 'react-toastify/dist/ReactToastify.css';
import '@reach/tabs/styles.css';
import '@reach/dialog/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-phone-input-2/lib/style.css';
import 'assets/styles/styles.css';
import 'assets/theme/default.css';

ReactDOM.render(
  <Router history={history}>
    <Provider store={store}>
      <ModalProvider>
        <ToastMarker limit={4} />
        <App />
      </ModalProvider>
    </Provider>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
